<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    @closed="onClosed"
  >
    <!-- 已回访：先展示详情，可点编辑 -->
    <div v-if="isViewed && !isEditing" class="visit-block">
      <div><strong>跟进情况：</strong>{{ currentVisit.summary || '—' }}</div>
      <div v-if="followType === 'student'"><strong>跟进阶段：</strong>{{ currentVisit.japState || '—' }}</div>
      <div><strong>回访时间：</strong>{{ formatVisitDate(currentVisit.date) }}</div>
      <div><strong>回访主题：</strong>{{ currentVisit.subject || '—' }}</div>
      <el-button type="primary" size="small" style="margin-top:12px" @click="isEditing = true">编辑</el-button>
    </div>
    <!-- 未回访 或 编辑中：表单 -->
    <el-form
      v-else
      ref="formRef"
      :model="form"
      label-width="100px"
      :status-icon="true"
      @submit.native.prevent="submitForm"
    >
      <el-form-item label="跟进情况" prop="summary">
        <el-input v-model="form.summary" type="textarea" :rows="3" placeholder="请输入跟进情况"></el-input>
      </el-form-item>
      <el-form-item v-if="followType === 'student'" label="跟进阶段" prop="stuState">
        <el-select v-model="form.stuState" placeholder="请选择" style="width:100%" clearable>
          <el-option v-for="item in stateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回访时间" prop="date">
        <el-date-picker
          v-model="form.date"
          value-format="yyyy-MM-dd HH:mm"
          type="datetime"
          placeholder="选择回访时间"
          style="width:100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="回访主题" prop="subject">
        <el-input v-model="form.subject" placeholder="请输入回访主题"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
        <el-button v-if="isViewed" @click="isEditing = false">取消</el-button>
        <el-button v-else @click="dialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  name: 'VisitDetailDialog',
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: () => null },
    /** 1=回访1，2=回访2 */
    whichVisit: { type: Number, default: 1 },
    /** student=留学(Follow)，jap=日语(Visit)，mingye=鸣野(Visit) */
    followType: { type: String, default: 'student' }
  },
  data() {
    return {
      isEditing: false,
      submiting: false,
      form: { summary: '', stuState: '', subject: '', date: '' },
      stateList: url.getStateData ? url.getStateData() : [],
      /** 打开弹窗时锁定的回访 ID，提交时用此 ID，避免 row 刷新导致错更新到另一条 */
      lockedVisitId: null
    };
  },
computed: {
    stateOptions() {
      return (this.stateList || []).filter(function(item) { return item.id != null && item.id !== ''; });
    },
    dialogVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    },
    dialogTitle() {
      const t = this.whichVisit === 2 ? '回访2' : '回访1';
      return this.isViewed && !this.isEditing ? t + '详情' : (this.visitId ? '编辑' + t : '填写' + t);
    },
    visitId() {
      const r = this.row || {};
      // 兼容后端 PascalCase / camelCase（visit1ID/Visit1ID），确保回访1编辑提交更新的是回访1的 ID
      const id1 = r.visit1Id != null ? r.visit1Id : (r.visit1ID != null ? r.visit1ID : r.Visit1ID);
      const id2 = r.visit2Id != null ? r.visit2Id : (r.visit2ID != null ? r.visit2ID : r.Visit2ID);
      const id = this.whichVisit === 2 ? id2 : id1;
      return id != null && id !== '' ? Number(id) : null;
    },
    stuid() {
      const r = this.row || {};
      return r.id != null ? r.id : (r.ID != null ? r.ID : (r.studentID != null ? r.studentID : r.StudentID));
    },
    isViewed() {
      const d = this.currentVisit.date;
      const s = this.currentVisit.subject;
      const sum = this.currentVisit.summary;
      return (d != null && d !== '') || (s != null && String(s).trim() !== '') || (sum != null && String(sum).trim() !== '');
    },
    currentVisit() {
      const r = this.row || {};
      const idx = this.whichVisit === 2 ? 2 : 1;
      const date = idx === 1 ? (r.visit1Date != null ? r.visit1Date : r.Visit1Date) : (r.visit2Date != null ? r.visit2Date : r.Visit2Date);
      const summary = idx === 1 ? (r.visit1Summary != null ? r.visit1Summary : (r.Visit1Summary != null ? r.Visit1Summary : '')) : (r.visit2Summary != null ? r.visit2Summary : (r.Visit2Summary != null ? r.Visit2Summary : ''));
      const subject = idx === 1 ? (r.visit1Subject != null ? r.visit1Subject : (r.Visit1Subject != null ? r.Visit1Subject : '')) : (r.visit2Subject != null ? r.visit2Subject : (r.Visit2Subject != null ? r.Visit2Subject : ''));
      const japState = idx === 1 ? (r.visit1JapState != null ? r.visit1JapState : (r.Visit1JapState != null ? r.Visit1JapState : '')) : (r.visit2JapState != null ? r.visit2JapState : (r.Visit2JapState != null ? r.Visit2JapState : ''));
      return {
        date,
        summary: (summary != null && typeof summary === 'string') ? summary.trim() : '',
        subject: (subject != null && typeof subject === 'string') ? subject.trim() : '',
        japState: (japState != null && typeof japState === 'string') ? japState.trim() : ''
      };
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.isEditing = !this.isViewed;
        this.form = {
          summary: this.currentVisit.summary,
          stuState: this.currentVisit.japState,
          subject: this.currentVisit.subject,
          date: this.formatDateForPicker(this.currentVisit.date)
        };
      }
    }
  },
  methods: {
    formatVisitDate(val) {
      if (val == null || val === '') return '—';
      if (typeof val === 'string') return val.length > 16 ? val.substring(0, 16) : val;
      if (typeof val === 'object' && val.toISOString) return val.toISOString().replace('T', ' ').substring(0, 16);
      return String(val);
    },
    formatDateForPicker(val) {
      if (val == null || val === '') return '';
      if (typeof val === 'string') return val.substring(0, 16);
      if (typeof val === 'object' && val.toISOString) return val.toISOString().replace('T', ' ').substring(0, 16);
      return '';
    },
    onClosed() {
      this.isEditing = false;
      this.lockedVisitId = null;
      this.$emit('closed');
    },
    submitForm() {
      const stuid = this.stuid;
      if (!stuid) {
        this.$message.warning('缺少学生信息');
        return;
      }
      this.submiting = true;
      if (this.followType === 'student') {
        const payload = {
          stuid,
          id: this.visitId || 0,
          isMingye: false,
          summary: this.form.summary,
          nextSubject: this.form.subject,
          nextDate: this.form.date,
          stuState: this.form.stuState
        };
        $.post(url.getStu('addorupdate_follow'), payload, res => {
          this.submiting = false;
          if (res.status) {
            this.$message.success(res.msg || '保存成功');
            this.dialogVisible = false;
            this.$emit('success');
          } else {
            this.$message.error(res.msg || '保存失败');
          }
        });
      } else {
        // 统一走「新增或编辑」接口：有 id 则更新该条，无 id 则新增；回访1/回访2各自编辑各自
        const vid = this.lockedVisitId != null ? this.lockedVisitId : this.visitId;
        const params = {
          id: (vid != null && vid > 0) ? vid : 0,
          stuid,
          summary: this.form.summary,
          subject: this.form.subject,
          noticeDate: this.form.date
        };
        $.post(url.getStu('AddOrUpdate_Visit_Simple'), params, res => {
          this.submiting = false;
          if (res.status) {
            this.$message.success(res.msg || '保存成功');
            this.dialogVisible = false;
            this.$emit('success');
          } else {
            this.$message.error(res.msg || '保存失败');
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.visit-block {
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
}
.visit-block > div {
  margin-bottom: 8px;
}
.visit-block > div:last-of-type {
  margin-bottom: 0;
}
</style>
